import * as React from 'react';
import { SVGProps } from 'react';

const IconGitHubSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.003 2c-2.25 0-4.07 1.833-4.07 4.101a4.098 4.098 0 0 0 2.783 3.891c.202.041.276-.088.276-.197 0-.095-.006-.42-.006-.76-1.133.244-1.369-.49-1.369-.49-.182-.474-.451-.597-.451-.597-.371-.25.027-.25.027-.25.41.026.627.42.627.42.363.625.95.448 1.186.34.033-.265.141-.449.256-.55-.903-.095-1.854-.449-1.854-2.024 0-.448.162-.815.418-1.1-.04-.102-.182-.523.04-1.086 0 0 .344-.11 1.12.42a3.915 3.915 0 0 1 2.035 0c.775-.53 1.119-.42 1.119-.42.223.563.08.984.04 1.086.263.285.418.652.418 1.1 0 1.575-.95 1.922-1.86 2.024.148.129.276.373.276.76 0 .55-.006.992-.006 1.127 0 .109.074.238.276.197a4.098 4.098 0 0 0 2.784-3.89C10.074 3.832 8.248 2 6.003 2Z"
    />
  </svg>
);
export default IconGitHubSizeXs;
